import { make } from "vuex-pathify";
import { getAPI, postAPI } from "@/store/restAPI.js";

// initial state
const state = {
  loading: false,
  user: null,
  userProfiles: null,
  pcUser: null,
  accessToken: null,
  userPromotion: null
};

// getters
const getters = {};

// actions
const actions = {
  loginFromCookie({ commit }) {
    var VueCookie = require('vue-cookie');
    var cookiePc = VueCookie.get('pc_authentication');

    if (cookiePc) {
      var cookieObj = JSON.parse(cookiePc);
      commit("SET_USER", cookieObj.user);
      commit("SET_ACCESS_TOKEN", cookieObj.token);
    }
  },
  login({ commit }, data) {
    var VueCookie = require('vue-cookie');
    commit("SET_USER", null);
    commit("SET_ACCESS_TOKEN", null);
    return postAPI("authentication/authenticate", {
      username: data.username,
      password: data.password
    }).then(function(response) {
      commit("SET_USER", response);
      commit("SET_USER_PROFILES", response.profiles);
      commit("SET_ACCESS_TOKEN", response.identification); //token
      response.profiles = null;
      VueCookie.set('pc_identification', JSON.stringify(response.identification), { expires: '12h' });
      VueCookie.set('pc_authentication', JSON.stringify(response.userId), { expires: '12h' });
    });
  },
  logout({ commit }) {
    commit("SET_USER", null);
    commit("SET_ACCESS_TOKEN", null);
    commit("SET_USER_PROFILES", null);
  },
  getUserData({ commit }) {
    var VueCookie = require('vue-cookie');
    var authentication = JSON.parse(VueCookie.get('pc_authentication'));
    return getAPI("security/getUserData", {
      userId: authentication.userId
    }).then(function(response) {
      commit("SET_USER_PROFILES", response.profiles);
      commit("SET_USER", response);
    });
  },
  getUsernameData({ commit }) {
    var VueCookie = require('vue-cookie');
    var username = JSON.parse(VueCookie.get('pc_authentication'));
    return getAPI("security/getUserDataByUsername", {
      username: username
    }).then(function(response) {
      commit("SET_USER_PROFILES", response.profiles);
      commit("SET_USER", response);
      commit("SET_ACCESS_TOKEN", response.identification); 
    });
  },
  getUserByUsername({ commit }, payload) {
    let username = payload.username;
    return getAPI("security/getUserDataByUsername", {
      username: username
    }).then(function(response) {
      commit("SET_USER_PROMOTION", response);
    });
  }
};

// mutations
const mutations = make.mutations(state);

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
